import { PlaceService } from '@/types/state/shared';

export function getOnlineFee(services: PlaceService[]) {
  return Math.max(0, ...services.map((s) => s.about?.settings?.onlineFee ?? 0));
}
